import { createIcon } from "@chakra-ui/icons";
export const InkwhaleLogo = createIcon({
  displayName: "InkwhaleLogo",
  viewBox: "0 0 45 42",
  path: (
    <>
      <path
        d="M31.314 14.354s.818 1.569 2.112 2.555l-.004-.037c-.908-7.668-7.304-13.61-15.059-13.61-6.513 0-12.068 4.191-14.218 10.078-.097.265-.186.534-.269.807.842.349 2.055 1.044 3.226 2.392.495.572 1.057 1.19 1.625 1.799l.254-.435s10.644 9.161 18.562 7.662c.576-.11 1.021-.159 1.352-.156.648-.261.915-.386.971-.408.093-.035 2.235-1.396 3.066-1.925.05-.179.099-.36.143-.542-.691-1.305-3.052-6.08-1.761-8.18Zm-18.125 2.75a1.089 1.089 0 0 1-1.078-1.1c0-.608.483-1.1 1.078-1.1.595 0 1.077.492 1.077 1.1 0 .607-.482 1.1-1.077 1.1Zm1.492 2.512a.42.42 0 0 1-.415-.424.42.42 0 0 1 .415-.424.42.42 0 0 1 .415.424.42.42 0 0 1-.415.424Zm.898-1.514a.605.605 0 0 1-.6-.611c0-.338.269-.612.6-.612.33 0 .599.273.599.611a.605.605 0 0 1-.6.612Zm-.546-3.624c-.934 0-1.691-.773-1.691-1.727 0-.953.757-1.726 1.69-1.726.934 0 1.691.773 1.691 1.726 0 .954-.757 1.727-1.69 1.727Z"
        fill="#A4F4F9"
      />
      <path
        d="M44.552 20.355a.49.49 0 0 0-.561-.22c-.02.005-1.985.575-3.547-.665-.994-.79-2.443-.928-3.717 -.712v-.008c0-.76-.045-1.525-.134-2.273C35.481 7.084 27.643 0 18.363 0c-3.818 0-7.48 1.186-10.587 3.428A18.666 18.666 0 0 0 1.152 12.2 19.029 19.029 0 0 0 0 18.683v.067c0 3.971 1.223 7.748 3.394 10.867-.187.982-.758 4.78 1.072 7.078.47.59.975 1.124 1.506 1.124a.778.778 0 0 0 .201-.026c.616-.163.746-.905.896-1.764.166-.952.333-1.71.767-1.913.514.367 1.049.71 1.604 1.026.215 2.232.956 4.331 3.2 5.707C13.91 41.627 14.8 42 15.437 42c.278 0 .507-.071.698-.21.716-.524.472-1.681.236-2.8-.103-.489-.291-1.38-.186-1.62.718.086 1.45.13 2.178.13 4.113 0 8-1.356 11.242-3.923a18.901 18.901 0 0 0 6.355-9.45c.518.075 1.425.15 2.537.003 1.587-.209 3.915-.928 5.992-3.163a.513.513 0 0 0 .063-.612ZM18.363 1.01c8.78 0 16.196 6.701 17.248 15.588.052.44.088.885.108 1.33a2.4 2.4 0 0 0-1.348-.97c-.87-.248-1.967-2.039-2.454-3.11a.491.491 0 0 0-.875-.044c-1.9 3.297.817 7.544 1.74 8.825-1.872 1.72-4.231 2.57-7.02 2.527-7.658-.12-16.241-6.765-18.501-9.172-1.704-1.815-3.127-2.713-4.23-2.67a1.458 1.458 0 0 0-.846.282 1.705 1.705 0 0 0-.513.214c.12-.424.255-.843.406-1.257C4.6 5.649 11.144 1.01 18.363 1.01ZM6.095 35.853c-.05.288-.121.696-.198.901-.11-.078-.319-.264-.664-.697-1.197-1.504-1.154-3.92-1-5.327a18.537 18.537 0 0 0 2.766 2.752c-.589.564-.765 1.574-.904 2.371Zm2.149-2.68a17.561 17.561 0 0 1-3.945-4.003 17.97 17.97 0 0 1-3.31-10.417c.008-1.297.38-4.028 1.489-4.186h.007c.075 0 .215.165.368.54.217.54.4 1.337.611 2.262.624 2.726 1.48 6.461 4.308 7.964 1.046.556 1.457 1.602 1.6 2.926-1.51-.996-2.115-2.257-2.121-2.27a.164.164 0 0 0-.22-.08.17.17 0 0 0-.078.225c.028.06.706 1.478 2.455 2.544.024.363.033.744.032 1.138-3.628-2.539-4.224-5.858-4.23-5.892a.166.166 0 0 0-.19-.138.168.168 0 0 0-.135.194c.006.038.163.954.836 2.206.593 1.106 1.714 2.683 3.715 4.034-.004.29-.013.587-.022.89-2.757-1.656-4.178-3.982-4.893-5.693-.826-1.98-.913-3.588-.913-3.604a.167.167 0 0 0-.173-.16.167.167 0 0 0-.156.177c.003.067.088 1.674.934 3.707.747 1.794 2.25 4.245 5.189 5.954-.011.356-.023.716-.03 1.08-3.448-2.039-5.166-5.205-6.005-7.543-.945-2.633-1.011-4.816-1.012-4.838a.166.166 0 0 0-.169-.164.167.167 0 0 0-.16.173c0 .022.066 2.25 1.028 4.934.87 2.43 2.67 5.734 6.312 7.82-.004.327-.003.654.005.98a17.433 17.433 0 0 1-1.126-.758l-.001-.001Zm30.168-10.05c-1.55.211-2.675-.06-2.685-.064a.494.494 0 0 0-.596.358c-2.05 7.698-8.945 13.073-16.768 13.073-.733 0-1.47-.047-2.192-.14h-.001a.4.4 0 0 0-.074-.003h-.03l-.006.002a.573.573 0 0 0-.045.006h-.002a.96.96 0 0 0-.637.43c-.363.56-.173 1.462.029 2.416.097.458.197.933.215 1.3.02.39-.059.466-.06.467-.004.002-.39.253-2.41-.985-1.934-1.187-2.564-3.037-2.739-5.088a.507.507 0 0 0-.015-.2c-.074-1.04-.039-2.129-.004-3.204.047-1.473.092-2.863-.146-4.072-.283-1.436-.942-2.411-2.017-2.982-2.425-1.289-3.22-4.762-3.801-7.299-.221-.967-.413-1.802-.66-2.416a3.604 3.604 0 0 0-.135-.295c.593.202 1.527.777 2.915 2.256 1.349 1.437 4.22 3.758 7.592 5.704 2.924 1.687 7.312 3.712 11.608 3.779l.218.001c3.127 0 5.76-1.05 7.829-3.123a.513.513 0 0 0 .036-.68c-.035-.044-3.142-3.979-2.313-7.125.559.985 1.518 2.387 2.589 2.692.804.23 1.033.952 1.098 1.295-.454.219-.88.532-.983.958a.506.506 0 0 0 .36.612.493.493 0 0 0 .594-.347c.089-.139.628-.475 1.529-.659 1.262-.257 2.434-.079 3.134.477.957.76 2.013.985 2.855 1.011a8.605 8.605 0 0 1-4.28 1.845h-.002Z"
        fill="#57527E"
      />
    </>
  ),
});

export const AzeroLogo = createIcon({
  displayName: "AzeroLogo",
  viewBox: "0 0 19 18",
  path: (
    <>
      <path
        fill={"#6CE5ED"}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.51 7.778h-4.13L11.13.383a.262.262 0 0 0-.241-.158H8.11c-.105 0-.2.062-.241.157L4.62 7.778H.49a.264.264 0 0 0-.264.264v1.916c0 .146.118.263.264.263h3.056L.388 17.406a.263.263 0 0 0 .242.369h2.382a.264.264 0 0 0 .244-.161L9.5 2.872l6.244 14.742a.264.264 0 0 0 .244.161h2.382a.264.264 0 0 0 .242-.369l-3.158-7.185h3.056a.263.263 0 0 0 .264-.263V8.042a.264.264 0 0 0-.264-.264Z"
      />
    </>
  ),
});

export const MenuIconBorder = createIcon({
  displayName: "MenuIconBorder",
  viewBox: "0 0 62 62",
  defaultProps: {
    width: "full",
    height: "full",
  },
  path: (
    <>
      <circle cx="31" cy="31" r="30" fill="none" stroke="currentColor" />
    </>
  ),
});

export const MenuIconBackground = createIcon({
  displayName: "MenuIconBackground",
  viewBox: "0 0 62 62",
  defaultProps: {
    width: "full",
    height: "full",
  },
  path: (
    <>
      <circle cx="31" cy="31" r="30" stroke="none" fill="currentColor" />
    </>
  ),
});

export const MyPoolsIcon = createIcon({
  displayName: "MyPoolsIcon",
  viewBox: "0 0 62 62",
  defaultProps: {
    width: "full",
    height: "full",
    fill: "none",
  },
  path: (
    <>
      <path
        d="M38.25 20.925h-16.5a.825.825 0 0 0-.825.825v16.5c0 .456.37.825.825.825h16.5c.456 0 .825-.37.825-.825v-16.5a.825.825 0 0 0-.825-.825Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m39.075 33.3-4.362-4.362a.827.827 0 0 0-1.176 0l-4.6 4.6a.824.824 0 0 1-1.175 0l-2.124-2.125a.827.827 0 0 0-1.176 0l-3.537 3.537"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.113 27.525a1.238 1.238 0 1 0 0-2.475 1.238 1.238 0 0 0 0 2.475Z"
        fill="currentColor"
      />
    </>
  ),
});

export const MyNFTFarmsIcon = createIcon({
  displayName: "MyNFTFarmsIcon",
  viewBox: "0 0 62 62",
  defaultProps: {
    width: "full",
    height: "full",
    fill: "none",
  },
  path: (
    <>
      <path
        d="M38.425 29.35v9.168a.732.732 0 0 1-.732.732H21.925a.825.825 0 0 1-.825-.825v-11.55a.825.825 0 0 1 .825-.825h4.672c.178 0 .351.059.495.165l2.866 2.145a.835.835 0 0 0 .495.165H37.6a.825.825 0 0 1 .825.825Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.4 26.05v-2.475a.825.825 0 0 1 .825-.825h4.672c.178 0 .351.059.495.165l2.866 2.145a.835.835 0 0 0 .495.165H40.9a.825.825 0 0 1 .825.825v9.168a.732.732 0 0 1-.732.732h-2.568"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export const MyLPFarmsIcon = createIcon({
  displayName: "MyLPFarmsIcon",
  viewBox: "0 0 62 62",
  defaultProps: {
    width: "full",
    height: "full",
    fill: "none",
  },
  path: (
    <>
      <path
        d="M31 28.969a4.063 4.063 0 1 0 0-8.125 4.063 4.063 0 0 0 0 8.125Zm6.094 10.562a4.063 4.063 0 1 0 0-8.125 4.063 4.063 0 0 0 0 8.125Zm-12.188 0a4.063 4.063 0 1 0 0-8.125 4.063 4.063 0 0 0 0 8.125Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export const MenuArrowRightIcon = createIcon({
  displayName: "MenuArrowRightIcon",
  viewBox: "0 0 14 14",
  path: (
    <path
      d="M2.188 7h9.624M7.875 3.063 11.813 7l-3.938 3.938"
      fill="none"
      strokeWidth="2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
// +++++++++++++++++++++++++++++++++++++++++++
export const HeroDotGroupTopLeftIcon = createIcon({
  displayName: "HeroDotGroupTopLeftIcon",
  viewBox: "0 0 44 120",
  path: (
    <path
      d="M40.67 114.12a2.437 2.437 0 0 1 2.436 2.434 2.437 2.437 0 0 1-4.872 0 2.437 2.437 0 0 1 2.436-2.434Zm0-19.02a2.437 2.437 0 0 1 2.436 2.434 2.437 2.437 0 0 1-4.872 0 2.437 2.437 0 0 1 2.436-2.435Zm0-19.021a2.437 2.437 0 0 1 2.436 2.434 2.437 2.437 0 0 1-4.872 0 2.437 2.437 0 0 1 2.436-2.434Zm0-19.021a2.437 2.437 0 0 1 2.436 2.435 2.437 2.437 0 0 1-4.872 0 2.437 2.437 0 0 1 2.436-2.435Zm0-19.017a2.437 2.437 0 0 1 2.436 2.434 2.437 2.437 0 0 1-4.872 0 2.435 2.435 0 0 1 2.436-2.434Zm0-19.021a2.437 2.437 0 0 1 2.436 2.435 2.437 2.437 0 0 1-4.872 0 2.435 2.435 0 0 1 2.436-2.434Zm0-19.02a2.437 2.437 0 0 1 2.436 2.435 2.437 2.437 0 0 1-4.872 0A2.437 2.437 0 0 1 40.67 0ZM22.06 114.12a2.437 2.437 0 0 1 2.435 2.434 2.437 2.437 0 0 1-4.872 0 2.437 2.437 0 0 1 2.436-2.434Zm0-19.02a2.437 2.437 0 0 1 2.435 2.434 2.437 2.437 0 0 1-4.872 0 2.437 2.437 0 0 1 2.436-2.435Zm0-19.021a2.437 2.437 0 0 1 2.435 2.434 2.437 2.437 0 0 1-4.872 0 2.437 2.437 0 0 1 2.436-2.434Zm0-19.021a2.437 2.437 0 0 1 2.435 2.435 2.437 2.437 0 0 1-4.872 0 2.437 2.437 0 0 1 2.436-2.435Zm0-19.017a2.437 2.437 0 0 1 2.435 2.434 2.437 2.437 0 0 1-4.872 0 2.435 2.435 0 0 1 2.436-2.434Zm0-19.021a2.437 2.437 0 0 1 2.435 2.435 2.437 2.437 0 0 1-4.872 0 2.435 2.435 0 0 1 2.436-2.434Zm0-19.02a2.437 2.437 0 0 1 2.435 2.435 2.437 2.437 0 0 1-4.872 0A2.437 2.437 0 0 1 22.059 0ZM5.168 114.836a2.437 2.437 0 0 0-3.445 0 2.433 2.433 0 0 0 0 3.443c.952.95 2.494.95 3.445 0a2.433 2.433 0 0 0 0-3.443Zm0-19.02a2.437 2.437 0 0 0-3.445 0 2.433 2.433 0 0 0 0 3.442 2.437 2.437 0 0 0 3.445 0 2.433 2.433 0 0 0 0-3.442Zm.54-18.244a2.437 2.437 0 0 0-4.502 1.863 2.437 2.437 0 0 0 4.502-1.863ZM3.449 57.058a2.437 2.437 0 0 1 2.436 2.435 2.437 2.437 0 0 1-4.872 0 2.435 2.435 0 0 1 2.436-2.435Zm0-19.018a2.437 2.437 0 0 1 2.436 2.435 2.437 2.437 0 0 1-4.872 0 2.433 2.433 0 0 1 2.436-2.434Zm0-19.02a2.437 2.437 0 0 1 2.436 2.435 2.437 2.437 0 0 1-4.872 0 2.433 2.433 0 0 1 2.436-2.434Zm0-19.02a2.437 2.437 0 0 1 2.436 2.434 2.437 2.437 0 0 1-4.872 0A2.435 2.435 0 0 1 3.449 0Z"
      fill="#E3ACE8"
    />
  ),
});

export const HeroDotGroupBottomRightIcon = createIcon({
  displayName: "HeroDotGroupBottomRightIcon",
  viewBox: "0 0 120 44",
  path: (
    <path
      d="M76.078 2.436A2.437 2.437 0 0 1 78.513 0a2.437 2.437 0 0 1 0 4.872 2.437 2.437 0 0 1-2.435-2.436Zm-19.02 0A2.437 2.437 0 0 1 59.492 0a2.437 2.437 0 0 1 0 4.872 2.437 2.437 0 0 1-2.434-2.436Zm-19.017 0A2.437 2.437 0 0 1 40.476 0a2.437 2.437 0 0 1 0 4.872 2.435 2.435 0 0 1-2.435-2.436Zm-19.021 0A2.437 2.437 0 0 1 21.456 0a2.437 2.437 0 0 1 0 4.872 2.435 2.435 0 0 1-2.434-2.436ZM0 2.436A2.437 2.437 0 0 1 2.435 0a2.437 2.437 0 0 1 0 4.872A2.437 2.437 0 0 1 0 2.436Zm76.078 18.611a2.437 2.437 0 0 1 2.435-2.436 2.437 2.437 0 0 1 0 4.872 2.437 2.437 0 0 1-2.435-2.436Zm-19.02 0a2.437 2.437 0 0 1 2.434-2.436 2.437 2.437 0 0 1 0 4.872 2.437 2.437 0 0 1-2.434-2.436Zm-19.017 0a2.437 2.437 0 0 1 2.435-2.436 2.437 2.437 0 0 1 0 4.872 2.435 2.435 0 0 1-2.435-2.436Zm-19.021 0a2.437 2.437 0 0 1 2.435-2.436 2.437 2.437 0 0 1 0 4.872 2.435 2.435 0 0 1-2.434-2.436Zm-19.02 0a2.437 2.437 0 0 1 2.435-2.436 2.437 2.437 0 0 1 0 4.872A2.437 2.437 0 0 1 0 21.047Zm77.572 16.351a2.437 2.437 0 0 0 1.863 4.502 2.437 2.437 0 0 0-1.863-4.502Zm-20.514 2.26a2.437 2.437 0 0 1 2.434-2.437 2.437 2.437 0 0 1 0 4.873 2.435 2.435 0 0 1-2.434-2.436Zm-19.017 0a2.437 2.437 0 0 1 2.435-2.437 2.437 2.437 0 0 1 0 4.873 2.433 2.433 0 0 1-2.435-2.436Zm-19.021 0a2.437 2.437 0 0 1 2.435-2.437 2.437 2.437 0 0 1 0 4.873 2.433 2.433 0 0 1-2.434-2.436Zm-19.02 0a2.437 2.437 0 0 1 2.435-2.437 2.437 2.437 0 0 1 0 4.873A2.435 2.435 0 0 1 0 39.658Z"
      fill="#E3ACE8"
    />
  ),
});

export const FeatureIcon1 = createIcon({
  displayName: "FeatureIcon1",
  viewBox: "0 0 78 81",
  defaultProps: { width: "full", height: "full" },
  path: (
    <>
      <path
        d="M40.083 0c30.395 0 40.084 9.427 40.084 39s-9.689 39-40.084 39C9.69 78 0 68.573 0 39S9.689 0 40.083 0Z"
        fill="#FEEEBD"
      />
      <path
        d="M20.333 39.5a1.206 1.206 0 1 1 2.412 0c0 9.99 8.098 18.088 18.088 18.088S58.921 49.49 58.921 39.5s-8.098-18.088-18.088-18.088a1.206 1.206 0 1 1 0-2.412c11.322 0 20.5 9.178 20.5 20.5S52.155 60 40.833 60s-20.5-9.178-20.5-20.5Zm20.5 13.867c-7.659 0-13.867-6.208-13.867-13.867 0-7.659 6.208-13.867 13.867-13.867 7.659 0 13.867 6.208 13.867 13.867 0 7.659-6.208 13.867-13.867 13.867Zm0-2.411c6.327 0 11.456-5.129 11.456-11.456S47.16 28.044 40.833 28.044 29.377 33.173 29.377 39.5s5.129 11.456 11.456 11.456Zm.852-5.78a1.205 1.205 0 0 1-1.705 0l-4.823-4.823a1.205 1.205 0 0 1 0-1.705l4.823-4.824a1.205 1.205 0 0 1 1.706 0l4.823 4.824c.471.47.471 1.234 0 1.705l-4.824 4.823Zm2.266-5.676-3.118-3.118-3.118 3.118 3.118 3.118L43.95 39.5Zm-20.59-4.681a1.206 1.206 0 1 1-2.33-.624 1.206 1.206 0 0 1 2.33.623Zm1.807-4.363a1.206 1.206 0 1 1-2.089-1.205 1.206 1.206 0 0 1 2.09 1.205Zm2.875-3.746a1.206 1.206 0 1 1-1.706-1.706 1.206 1.206 0 0 1 1.706 1.706Zm3.746-2.875a1.205 1.205 0 1 1-1.206-2.087 1.205 1.205 0 0 1 1.206 2.087Zm4.362-1.807a1.206 1.206 0 1 1-.624-2.33 1.206 1.206 0 0 1 .624 2.33Z"
        fill="#57527E"
      />
    </>
  ),
});

export const FeatureIcon2 = createIcon({
  displayName: "FeatureIcon2",
  viewBox: "0 0 78 81",
  defaultProps: { width: "full", height: "full" },

  path: (
    <>
      <path
        d="M40.083 0c30.395 0 40.084 9.427 40.084 39s-9.689 39-40.084 39C9.69 78 0 68.573 0 39S9.689 0 40.083 0Z"
        fill="#FED1CA"
      />
      <path
        d="M58.469 32.602a1.378 1.378 0 0 0-.383-.877l-7.325-7.326c-.26-.265-.61-.361-.963-.399H29.042c-.753 0-1.363.61-1.363 1.363V34.5h-4.617v-1.564a1.362 1.362 0 1 0-2.725 0v2.906c-.018.38.15.736.397.985.25.248.605.415.985.398h5.96v2.646H21.7a1.362 1.362 0 1 0 0 2.726h5.98v2.646h-5.96a1.33 1.33 0 0 0-.985.398 1.358 1.358 0 0 0-.401.965c0 .007.004.013.004.02v2.906a1.362 1.362 0 1 0 2.725 0V47.97h4.617v9.138c0 .754.61 1.363 1.363 1.363h28.081c.753 0 1.363-.61 1.363-1.363v-24.42c0-.03-.015-.057-.017-.086Zm-4.636-1.277H51.16v-2.673l2.673 2.673Zm-23.428 24.42v-29.02h18.03v5.963c0 .753.61 1.362 1.363 1.362h5.963v21.694H30.404Z"
        fill="#57527E"
      />
      <path
        d="M47.067 36.798v-.912a3.99 3.99 0 0 0-3.984-3.985 3.99 3.99 0 0 0-3.986 3.985v.912a3.495 3.495 0 0 0-2.93 3.44v6.834a3.502 3.502 0 0 0 3.498 3.498h6.833a3.502 3.502 0 0 0 3.499-3.498v-6.833a3.495 3.495 0 0 0-2.93-3.441Zm-3.984-2.172a1.26 1.26 0 0 1 1.258 1.26v.854h-2.519v-.854c0-.694.566-1.26 1.26-1.26Zm4.189 12.445a.775.775 0 0 1-.774.773h-6.833a.775.775 0 0 1-.773-.773v-6.833c0-.425.348-.773.773-.773h6.833c.426 0 .774.347.774.773v6.833Z"
        fill="#57527E"
      />
    </>
  ),
});

export const FeatureIcon3 = createIcon({
  displayName: "FeatureIcon3",
  viewBox: "0 0 78 81",
  defaultProps: { width: "full", height: "full" },
  path: (
    <>
      <path
        d="M40.083 0c30.395 0 40.084 9.427 40.084 39s-9.689 39-40.084 39C9.69 78 0 68.573 0 39S9.689 0 40.083 0Z"
        fill="#E8FDFF"
      />
      <path
        d="M59.612 37.704a.824.824 0 0 0-.816.831c0 .46.365.832.816.832.109 0 .212.044.289.122a.42.42 0 0 1 .12.294V53.92a.42.42 0 0 1-.12.294.404.404 0 0 1-.289.122H21.237a.412.412 0 0 1-.409-.416V39.783c0-.23.183-.416.409-.416.45 0 .816-.372.816-.832a.824.824 0 0 0-.816-.831c-.542 0-1.061.219-1.444.608a2.1 2.1 0 0 0-.598 1.47v14.139a2.1 2.1 0 0 0 .598 1.47c.383.39.902.609 1.444.609h38.375c.542 0 1.061-.22 1.444-.609.383-.39.598-.919.598-1.47V39.783a2.1 2.1 0 0 0-.598-1.47 2.023 2.023 0 0 0-1.444-.61Z"
        fill="#57527E"
        stroke="#57527E"
        strokeWidth="1.5"
      />
      <path
        d="M24.602 45.914a.827.827 0 0 0-.833.82c0 .454.373.822.833.822h31.65c.46 0 .833-.368.833-.821a.827.827 0 0 0-.833-.821h-3.185a16.594 16.594 0 0 0 4.33-11.781 16.628 16.628 0 0 0-5.182-11.443A17.116 17.116 0 0 0 40.425 18a17.117 17.117 0 0 0-11.79 4.69 16.63 16.63 0 0 0-5.183 11.443 16.59 16.59 0 0 0 4.33 11.78h-3.18Zm.508-11.172c-.002-5.107 2.616-9.87 6.958-12.656a15.513 15.513 0 0 1 14.559-1.154c4.738 2.067 8.095 6.355 8.921 11.396.827 5.042-.989 10.154-4.826 13.585h-20.59a15.012 15.012 0 0 1-5.022-11.172Z"
        fill="#57527E"
        stroke="#57527E"
        strokeWidth="1.5"
      />
      <path
        d="m48.276 34.285-7-7.592a.743.743 0 0 0-1.108 0l-6.999 7.592a.89.89 0 0 0-.23.604.89.89 0 0 0 .23.604l7 7.592a.743.743 0 0 0 1.108 0l6.999-7.592a.89.89 0 0 0 .23-.604.89.89 0 0 0-.23-.604Zm-7.554 6.99-5.898-6.401 5.898-6.402 5.898 6.402-5.898 6.402Z"
        fill="#57527E"
        stroke="#57527E"
        strokeWidth="1.5"
      />
    </>
  ),
});

export const FeatureIcon4 = createIcon({
  displayName: "FeatureIcon4",
  viewBox: "0 0 78 81",
  defaultProps: { width: "full", height: "full" },
  path: (
    <>
      <path
        d="M39.972 0c30.31 0 39.973 9.427 39.973 39s-9.662 39-39.973 39C9.662 78 0 68.573 0 39S9.662 0 39.972 0Z"
        fill="#FFD6EB"
      />
      <path
        d="M39.451 33.525c-6.37 0-11.552 5.157-11.552 11.497 0 6.339 5.182 11.496 11.552 11.496 6.37 0 11.552-5.157 11.552-11.496 0-6.34-5.182-11.497-11.552-11.497Zm0 21.314c-5.44 0-9.865-4.404-9.865-9.817 0-5.414 4.426-9.818 9.865-9.818 5.44 0 9.865 4.404 9.865 9.818 0 5.413-4.425 9.817-9.865 9.817Zm3.723-7.212c0 1.604-1.223 2.952-2.862 3.307l.017.715a.842.842 0 0 1-.823.86h-.021a.842.842 0 0 1-.843-.82l-.018-.74c-.952-.189-1.57-.698-2.16-1.252a.837.837 0 0 1-.035-1.188.846.846 0 0 1 1.193-.034c.684.643 1.064.87 1.83.87 1.122 0 2.035-.77 2.035-1.718s-.913-1.72-2.035-1.72c-2.053 0-3.723-1.523-3.723-3.398 0-1.604 1.224-2.952 2.865-3.307l-.02-.808a.844.844 0 0 1 1.687-.04l.022.87c.893.214 1.953.727 2.428 1.448a.838.838 0 0 1-.241 1.163.847.847 0 0 1-1.169-.24c-.228-.346-1.282-.804-1.85-.804-1.121 0-2.034.772-2.034 1.72 0 .947.913 1.718 2.035 1.718 2.052 0 3.722 1.525 3.722 3.398Zm-2.88-17.56v-4.836a9.192 9.192 0 0 0 5.525-1.177 9.071 9.071 0 0 0 4.314-5.687.84.84 0 0 0-.587-1.012 9.148 9.148 0 0 0-7.106.874 9.126 9.126 0 0 0-2.989 2.752 9.121 9.121 0 0 0-2.988-2.752 9.15 9.15 0 0 0-7.106-.874.839.839 0 0 0-.587 1.012 9.069 9.069 0 0 0 4.314 5.687 9.197 9.197 0 0 0 5.524 1.177v4.836c-7.908.437-14.207 6.978-14.207 14.954C24.4 53.281 31.151 60 39.451 60c8.299 0 15.05-6.72 15.05-14.978 0-7.977-6.299-14.517-14.207-14.954Zm2.99-10.383a7.456 7.456 0 0 1 4.954-.903 7.399 7.399 0 0 1-3.263 3.819 7.508 7.508 0 0 1-4.68.94v-.665a7.417 7.417 0 0 1 2.989-3.19ZM33.927 22.6a7.398 7.398 0 0 1-3.263-3.819 7.453 7.453 0 0 1 4.955.903 7.418 7.418 0 0 1 2.988 3.191v.665a7.5 7.5 0 0 1-4.68-.94Zm5.524 35.72c-7.368 0-13.363-5.965-13.363-13.298 0-7.334 5.995-13.3 13.363-13.3 7.369 0 13.363 5.966 13.363 13.3 0 7.333-5.994 13.298-13.363 13.298Z"
        fill="#57527E"
        stroke="#57527E"
        strokeWidth=".7"
      />
    </>
  ),
});

export const FeatureIconBorder = createIcon({
  displayName: "FeatureIconBorder",
  viewBox: "0 0 114 114",
  defaultProps: {
    width: "full",
    height: "full",
    stroke: "black",
    _hover: { stroke: "blue" },
    sx: {
      "#card-wrapper:hover &": {
        color: "red",
      },
    },
  },
  path: (
    <>
      <path
        d="M57 1c21.566 0 35.454 3.452 44.001 11.999C109.548 21.545 113 35.434 113 57s-3.452 35.454-11.999 44.001C92.454 109.548 78.566 113 57 113s-35.454-3.452-44.001-11.999C4.452 92.454 1 78.566 1 57s3.452-35.454 11.999-44.001C21.545 4.452 35.434 1 57 1Z"
        fill="currentColor"
        // stroke="#E3DFF3"
        stroke="currentColor"
        strokeWidth="2"
      />
    </>
  ),
});

export const FeatureIconBackground = createIcon({
  displayName: "FeatureIconBorder",
  viewBox: "0 0 114 114",
  defaultProps: {
    width: "full",
    height: "full",
  },
  path: (
    <>
      <path
        d="M57 1c21.566 0 35.454 3.452 44.001 11.999C109.548 21.545 113 35.434 113 57s-3.452 35.454-11.999 44.001C92.454 109.548 78.566 113 57 113s-35.454-3.452-44.001-11.999C4.452 92.454 1 78.566 1 57s3.452-35.454 11.999-44.001C21.545 4.452 35.434 1 57 1Z"
        fill="currentColor"
        // stroke="#E3DFF3"
        stroke="currentColor"
        strokeWidth="2"
      />
    </>
  ),
});

export const FeatureIcon5 = createIcon({
  displayName: "FeatureIcon5",
  viewBox: "0 0 114 114",
  defaultProps: {
    width: "full",
    height: "full",
    color: "#FFA0D2",
    _hover: { color: "#FFF" },
  },
  path: (
    <>
      <path
        d="M78.238 62.632v11.146a13.45 13.45 0 0 1-2.93 8.374v2.906a2.967 2.967 0 0 1-.852 2.079 2.889 2.889 0 0 1-2.052.863h-14.79a2.889 2.889 0 0 1-2.051-.863 2.967 2.967 0 0 1-.852-2.079V82l-5.99-7.502a6.818 6.818 0 0 1-1.434-5.06 6.773 6.773 0 0 1 2.585-4.564l2.013-1.55V47.648a3.961 3.961 0 0 1 1.138-2.78 3.86 3.86 0 0 1 2.744-1.154h.282a3.86 3.86 0 0 1 2.742 1.154 3.963 3.963 0 0 1 1.138 2.78v7.547c1.048-1.621 2.222-1.54 2.222-1.54 1.727 0 3.195 2.163 3.697 3.747 1.12-1.678 2.405-1.654 2.405-1.654 1.992 0 3.64 2.415 3.857 4.376a3.21 3.21 0 0 1 2.246-1.427A3.862 3.862 0 0 1 77.1 59.85a3.966 3.966 0 0 1 1.138 2.781Z"
        fill="currentColor"
      />
      <path
        d="M70.857 49.62h-3.325c0-4.143-2.32-7.972-6.087-10.043a12.706 12.706 0 0 0-12.176 0c-3.767 2.071-6.087 5.9-6.087 10.042h-3.325c0-5.274 2.954-10.147 7.75-12.784 4.796-2.637 10.704-2.637 15.5 0 4.796 2.637 7.75 7.51 7.75 12.784Z"
        fill="currentColor"
      />
      <path
        d="M79.712 49.619H76.38c0-5.407-2.215-10.592-6.157-14.415-3.943-3.824-9.29-5.972-14.866-5.972-5.575 0-10.923 2.148-14.865 5.972-3.943 3.823-6.158 9.008-6.158 14.415H31c0-6.264 2.566-12.272 7.134-16.7C42.702 28.488 48.897 26 55.357 26c6.46 0 12.655 2.488 17.224 6.918 4.567 4.43 7.133 10.437 7.133 16.701h-.002Z"
        fill="currentColor"
      />
    </>
  ),
});

export const FeatureIcon6 = createIcon({
  displayName: "FeatureIcon6",
  viewBox: "0 0 114 114",
  defaultProps: {
    width: "full",
    height: "full",
    color: "#CDA1F6",
    _hover: { color: "#FFF" },
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m52.318 34.097-4.571-1.243c-2.292-.623-4.65.759-5.265 3.082l-1.45 5.485h-4.733c-2.373 0-4.299 1.952-4.299 4.358v34.863C32 83.048 33.926 85 36.3 85h22.928c2.374 0 4.3-1.952 4.3-4.358v-.845l1.36-5.143L82.41 45.181l.014-.023c1.187-2.083.48-4.75-1.573-5.953l-19.858-11.62c-2.055-1.204-4.685-.49-5.872 1.594l-2.802 4.919-.001-.001ZM48.5 53.354a1.408 1.408 0 0 0-1.473 0l-7.166 4.358a1.453 1.453 0 0 0-.696 1.245v8.715c0 .51.264.984.696 1.246l7.166 4.357c.452.278 1.02.278 1.473 0l7.165-4.358c.432-.261.696-.734.696-1.245v-8.715c0-.51-.264-.984-.696-1.245L48.5 53.354Zm-.737 2.938 5.732 3.487v7.071l-5.732 3.486-5.732-3.486v-7.071l5.732-3.487Zm4.854-19.107-5.612-1.524a1.432 1.432 0 0 0-1.756 1.027L44 41.421h15.228c2.373 0 4.3 1.953 4.3 4.358v22.792l6.639-25.114a1.456 1.456 0 0 0-1.014-1.78L52.663 37.2a1.512 1.512 0 0 0-.046-.013v-.001Zm14.949 27.334c5.193-8.737 12.383-20.83 12.389-20.839a1.465 1.465 0 0 0-.538-1.96L59.561 30.098a1.423 1.423 0 0 0-1.958.531l-2.418 4.243 14.711 3.996c2.293.622 3.654 3.014 3.041 5.337l-5.37 20.313Z"
        fill="currentColor"
      />
    </>
  ),
});

export const FeatureIcon7 = createIcon({
  displayName: "FeatureIcon7",
  viewBox: "0 0 114 114",
  defaultProps: {
    width: "full",
    height: "full",
    color: "#FFDA6E",
    _hover: { color: "#FFF" },
  },
  path: (
    <>
      <path
        d="M57.5 45.1c-4.179 0-8.078 1.425-11.143 3.705V45.1c0-6.27 5.014-11.4 11.143-11.4 6.129 0 11.143 5.13 11.143 11.4h5.571c0-9.405-7.521-17.1-16.714-17.1-9.193 0-16.714 7.695-16.714 17.1v9.69C39.114 57.925 38 61.345 38 65.05 38 76.165 46.636 85 57.5 85S77 76.165 77 65.05c0-11.115-8.636-19.95-19.5-19.95Zm5.571 28.5H51.93l1.671-7.125c-1.114-1.14-1.671-2.565-1.671-4.275 0-3.135 2.507-5.7 5.571-5.7 3.064 0 5.571 2.565 5.571 5.7 0 1.71-.557 3.135-1.671 4.275L63.07 73.6Z"
        fill="currentColor"
      />
    </>
  ),
});

export const FeatureIcon8 = createIcon({
  displayName: "FeatureIcon8",
  viewBox: "0 0 114 114",
  defaultProps: {
    width: "full",
    height: "full",
    color: "#F59A86",
    _hover: { color: "#FFF" },
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.5 61.779c-7.818 0-14.178-6.38-14.178-14.22 0-7.842 6.36-14.22 14.178-14.22 7.819 0 14.178 6.378 14.178 14.22 0 7.84-6.36 14.22-14.177 14.22ZM57.5 28C46.748 28 38 36.774 38 47.558s8.748 19.559 19.5 19.559c10.753 0 19.5-8.774 19.5-19.559C77 36.773 68.252 28 57.5 28M44.74 65.234v19.629A1.138 1.138 0 0 0 45.873 86c.167 0 .334-.037.489-.11l3.984-1.91V68.179a21.695 21.695 0 0 1-5.606-2.944m12.76 4.157c-1.68 0-3.315-.192-4.886-.555v14.058l4.887-2.34 4.886 2.34V68.836a21.694 21.694 0 0 1-4.886.555Zm7.154-1.213V83.98l3.985 1.908c.351.168.764.144 1.093-.064.33-.209.53-.572.53-.962v-19.63a21.706 21.706 0 0 1-5.608 2.945m-5.987-24.093-1.167-2.37-1.166 2.37a2.218 2.218 0 0 1-1.67 1.217l-2.608.38 1.887 1.846c.523.51.761 1.246.638 1.968l-.446 2.605 2.333-1.23a2.21 2.21 0 0 1 2.064 0l2.333 1.23-.446-2.605a2.226 2.226 0 0 1 .638-1.968l1.887-1.846-2.608-.38a2.218 2.218 0 0 1-1.67-1.216m5.935 3.153-1.942 1.899.458 2.68a2.213 2.213 0 0 1-.882 2.175 2.206 2.206 0 0 1-2.335.17l-2.4-1.266-2.4 1.266a2.198 2.198 0 0 1-2.335-.17 2.214 2.214 0 0 1-.882-2.175l.458-2.68-1.941-1.899a2.214 2.214 0 0 1-.562-2.28 2.205 2.205 0 0 1 1.79-1.513l2.684-.39 1.2-2.44a2.203 2.203 0 0 1 1.988-1.24c.85 0 1.612.476 1.988 1.24l1.2 2.44 2.684.39a2.205 2.205 0 0 1 1.79 1.514c.262.81.047 1.684-.562 2.28M57.5 35.61c-6.568 0-11.91 5.36-11.91 11.946 0 6.587 5.343 11.946 11.91 11.946s11.91-5.359 11.91-11.946S64.067 35.61 57.5 35.61"
        fill="currentColor"
      />
    </>
  ),
});

export const TelegramIcon = createIcon({
  displayName: "TelegramIcon",
  viewBox: "0 0 20 17",
  defaultProps: { width: "full", height: "full" },
  path: (
    <>
      <path
        d="M19.5391 2.00391C19.7969 0.800781 19.1094 0.328125 18.3359 0.628906L1.23438 7.20312C0.0742188 7.67578 0.117188 8.32031 1.0625 8.62109L5.40234 9.95312L15.543 3.59375C16.0156 3.25 16.4883 3.46484 16.1016 3.76562L7.89453 11.1562L7.59375 15.668C8.06641 15.668 8.23828 15.4961 8.49609 15.2383L10.6016 13.1758L15.0273 16.4414C15.8438 16.9141 16.4453 16.6562 16.6602 15.7109L19.5391 2.00391Z"
        fill="currentColor"
      />
    </>
  ),
});

export const DiscordIcon = createIcon({
  displayName: "DiscordIcon",
  viewBox: "0 0 20 17",
  defaultProps: { width: "full", height: "full" },
  path: (
    <>
      <path
        d="M12.793 10.332C13.0221 10.5612 13.1367 10.8477 13.1367 11.1914C13.1367 11.5352 13.0221 11.8359 12.793 12.0938C12.5924 12.3229 12.3346 12.4375 12.0195 12.4375C11.819 12.4375 11.6328 12.3802 11.4609 12.2656C11.2891 12.151 11.1458 12.0078 11.0312 11.8359C10.9453 11.6354 10.9023 11.4206 10.9023 11.1914C10.9023 11.0195 10.931 10.862 10.9883 10.7188C11.0456 10.5755 11.1172 10.4466 11.2031 10.332C11.3177 10.2174 11.4466 10.1315 11.5898 10.0742C11.7331 10.0169 11.8763 9.98828 12.0195 9.98828C12.3346 9.98828 12.5924 10.1029 12.793 10.332ZM7.20703 10.332C7.4362 10.1029 7.70833 9.98828 8.02344 9.98828C8.33854 9.98828 8.59635 10.1029 8.79688 10.332C9.02604 10.5612 9.14062 10.8477 9.14062 11.1914C9.14062 11.5352 9.02604 11.8359 8.79688 12.0938C8.59635 12.3229 8.33854 12.4375 8.02344 12.4375C7.70833 12.4375 7.4362 12.3229 7.20703 12.0938C7.00651 11.8359 6.90625 11.5352 6.90625 11.1914C6.90625 10.8477 7.00651 10.5612 7.20703 10.332ZM19.625 3.02734V22.75C17.9635 21.2891 16.2591 19.7422 14.5117 18.1094L15.1133 20.1719H2.60938C2.00781 20.1719 1.47786 19.957 1.01953 19.5273C0.589844 19.069 0.375 18.5247 0.375 17.8945V3.02734C0.375 2.39714 0.589844 1.86719 1.01953 1.4375C1.47786 0.979167 2.00781 0.75 2.60938 0.75H17.3906C17.9922 0.75 18.5078 0.979167 18.9375 1.4375C19.3958 1.86719 19.625 2.39714 19.625 3.02734ZM16.4883 13.4258C16.4883 12.3945 16.3594 11.349 16.1016 10.2891C15.8438 9.20052 15.5716 8.38411 15.2852 7.83984L14.8984 7.02344C14.612 6.79427 14.2969 6.60807 13.9531 6.46484C13.638 6.29297 13.3516 6.17839 13.0938 6.12109C12.8646 6.03516 12.6497 5.97786 12.4492 5.94922C12.2487 5.89193 12.0911 5.86328 11.9766 5.86328H11.8047L11.6758 6.03516C12.2201 6.20703 12.7214 6.42188 13.1797 6.67969C13.638 6.90885 13.9531 7.09505 14.125 7.23828L14.3828 7.45312C13.1224 6.73698 11.7474 6.36458 10.2578 6.33594C8.76823 6.30729 7.40755 6.5651 6.17578 7.10938L5.53125 7.45312C6.13281 6.88021 7.09245 6.39323 8.41016 5.99219L8.32422 5.86328C7.32161 5.86328 6.29036 6.25 5.23047 7.02344C5.11589 7.2526 4.97266 7.55339 4.80078 7.92578C4.62891 8.29818 4.38542 9.05729 4.07031 10.2031C3.78385 11.3203 3.64062 12.3945 3.64062 13.4258C3.69792 13.569 3.79818 13.7266 3.94141 13.8984C4.11328 14.0703 4.48568 14.3138 5.05859 14.6289C5.63151 14.944 6.27604 15.1016 6.99219 15.1016C7.27865 14.7865 7.52214 14.4857 7.72266 14.1992C7.32161 14.0846 6.94922 13.9271 6.60547 13.7266C6.29036 13.4974 6.07552 13.2969 5.96094 13.125L5.78906 12.9102C5.84635 12.9388 5.90365 12.9818 5.96094 13.0391C6.04688 13.0677 6.11849 13.0964 6.17578 13.125C6.23307 13.1536 6.26172 13.168 6.26172 13.168C7.23568 13.7122 8.3099 14.0417 9.48438 14.1562C10.6875 14.2422 11.9049 14.0417 13.1367 13.5547C13.5664 13.4115 13.9818 13.1966 14.3828 12.9102C14.0104 13.5117 13.3516 13.9557 12.4062 14.2422L13.1367 15.1016C13.5951 15.1016 14.0104 15.0443 14.3828 14.9297C14.7839 14.7865 15.099 14.6432 15.3281 14.5C15.5859 14.3281 15.8008 14.1706 15.9727 14.0273C16.1732 13.8555 16.3021 13.7122 16.3594 13.5977L16.4883 13.4258Z"
        fill="currentColor"
      />
    </>
  ),
});

export const TwitterIcon = createIcon({
  displayName: "TwitterIcon",
  viewBox: "0 0 20 17",
  defaultProps: { width: "full", height: "full" },
  path: (
    <>
      <path
        d="M19.7227 5.28125C20.582 4.63672 21.3555 3.86328 21.957 2.96094C21.1836 3.30469 20.2812 3.5625 19.3789 3.64844C20.3242 3.08984 21.0117 2.23047 21.3555 1.15625C20.4961 1.67188 19.5078 2.05859 18.5195 2.27344C17.6602 1.37109 16.5 0.855469 15.2109 0.855469C12.7188 0.855469 10.6992 2.875 10.6992 5.36719C10.6992 5.71094 10.7422 6.05469 10.8281 6.39844C7.08984 6.18359 3.73828 4.37891 1.50391 1.67188C1.11719 2.31641 0.902344 3.08984 0.902344 3.94922C0.902344 5.49609 1.67578 6.87109 2.92188 7.6875C2.19141 7.64453 1.46094 7.47266 0.859375 7.12891V7.17188C0.859375 9.36328 2.40625 11.168 4.46875 11.5977C4.125 11.6836 3.69531 11.7695 3.30859 11.7695C3.00781 11.7695 2.75 11.7266 2.44922 11.6836C3.00781 13.4883 4.68359 14.7773 6.66016 14.8203C5.11328 16.0234 3.17969 16.7539 1.07422 16.7539C0.6875 16.7539 0.34375 16.7109 0 16.668C1.97656 17.957 4.33984 18.6875 6.91797 18.6875C15.2109 18.6875 19.7227 11.8555 19.7227 5.88281C19.7227 5.66797 19.7227 5.49609 19.7227 5.28125Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CopyIcon = createIcon({
  displayName: "CopyIcon",
  viewBox: "0 0 20 21",
  defaultProps: { width: "full", height: "full", fill: "none" },
  path: (
    <>
      <path
        d="M13.125 13.625h3.75v-10h-10v3.75"
        // stroke="#8C86A5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 7.375h-10v10h10v-10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export const WebsiteIcon = createIcon({
  displayName: "websiteIcon",
  viewBox: "0 0 22 21",
  defaultProps: { width: "full", height: "full" },
  path: (
    <>
      <path
        d="M11 0.375C8.99747 0.375 7.0399 0.968821 5.37486 2.08137C3.70981 3.19392 2.41206 4.77523 1.64572 6.62533C0.879387 8.47543 0.678878 10.5112 1.06955 12.4753C1.46023 14.4393 2.42454 16.2435 3.84055 17.6595C5.25656 19.0755 7.06066 20.0398 9.02471 20.4305C10.9888 20.8211 13.0246 20.6206 14.8747 19.8543C16.7248 19.0879 18.3061 17.7902 19.4186 16.1251C20.5312 14.4601 21.125 12.5025 21.125 10.5C21.122 7.8156 20.0543 5.24199 18.1562 3.34383C16.258 1.44567 13.6844 0.377978 11 0.375ZM18.7934 9.375H15.8338C15.6888 7.21364 15.0639 5.11176 14.0047 3.22219C15.2671 3.7457 16.372 4.58787 17.2114 5.66636C18.0508 6.74484 18.5959 8.02271 18.7934 9.375ZM8.42282 11.625H13.5791C13.3681 14.1272 12.4541 16.4494 11.0019 18.1734C9.54313 16.4494 8.63375 14.1272 8.42282 11.625ZM8.42282 9.375C8.63375 6.87281 9.54313 4.55062 11 2.82656C12.4569 4.55062 13.3663 6.87281 13.5772 9.375H8.42282ZM8 3.22219C6.93912 5.11137 6.31268 7.21328 6.16625 9.375H3.20657C3.40455 8.02221 3.95037 6.744 4.79062 5.66547C5.63086 4.58694 6.73673 3.74505 8 3.22219ZM3.20657 11.625H6.16625C6.31268 13.7867 6.93912 15.8886 8 17.7778C6.73673 17.255 5.63086 16.4131 4.79062 15.3345C3.95037 14.256 3.40455 12.9778 3.20657 11.625ZM14.0047 17.7778C15.0639 15.8882 15.6888 13.7864 15.8338 11.625H18.7934C18.5959 12.9773 18.0508 14.2552 17.2114 15.3336C16.372 16.4121 15.2671 17.2543 14.0047 17.7778Z"
        fill="currentColor"
      />
    </>
  ),
});
